import { compose } from 'recompose';

import TabContentView from './TabContentView';

export default compose()(TabContentView);
